import { render, staticRenderFns } from "./MPopupYesNo.vue?vue&type=template&id=5f340b01&"
import script from "./MPopupYesNo.vue?vue&type=script&lang=ts&"
export * from "./MPopupYesNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports